// PROLIFT · Industrial Precision Theme
// Paleta inspirada en señalética de seguridad de ascensores y estética de
// ingeniería: azul corporativo (marca), naranja industrial (alerta),
// verde inspección (pasa), amarillo señal (revisión), rojo detención.

export const primaryColor = '#0055b3'; // marca — no cambia
export const infoColor = '#1b4f72'; // azul de plano técnico
export const warningColor = '#c5561d'; // naranja de señalética
export const errorColor = '#9b2a1e'; // rojo "detención"
export const successColor = '#2e6b3a'; // verde "aprobado"
export const signalColor = '#b8861a'; // amarillo "inspección"

export const neutral = {
  bg: '#f6f7f9',
  surface: '#ffffff',
  surfaceRaised: '#ffffff',
  border: '#e2e6eb',
  borderSoft: '#eef1f4',
  borderStrong: '#cbd2d9',
  text: '#1e293b',
  // Subido para que pase WCAG AA: ~6.6:1 sobre bg slate.
  textMuted: '#475569',
  // Antes era #94a3b8 (2.9:1 — falla AA). Ahora 4.4:1; sólo para texto muy
  // secundario (timestamps, marcadores decorativos).
  textFade: '#64748b',
  ink: '#0f172a',
};

export const elevation = {
  sh1: '0 1px 2px 0 rgba(15, 23, 42, 0.06)',
  sh2: '0 2px 8px -2px rgba(15, 23, 42, 0.08), 0 1px 2px 0 rgba(15, 23, 42, 0.06)',
  sh3: '0 12px 24px -8px rgba(15, 23, 42, 0.12), 0 2px 6px -2px rgba(15, 23, 42, 0.08)',
};

export const motion = {
  fast: '0.08s',
  mid: '0.16s',
  slow: '0.24s',
  ease: 'cubic-bezier(0.22, 0.8, 0.32, 1)',
};

export const fontStack = {
  sans: "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
  mono: "'IBM Plex Mono', 'SFMono-Regular', Menlo, Consolas, monospace",
};
